import { render, staticRenderFns } from "./RecordingMergeRequestDetail.vue?vue&type=template&id=7a7c93f8&"
import script from "./RecordingMergeRequestDetail.vue?vue&type=script&lang=js&"
export * from "./RecordingMergeRequestDetail.vue?vue&type=script&lang=js&"
import style0 from "./RecordingMergeRequestDetail.vue?vue&type=style&index=0&id=7a7c93f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports